export default {"src":"/_next/static/media/payments-ru.43c4ce78.svg","height":19,"width":125,"blurWidth":0,"blurHeight":0};